module.exports = __webpack_public_path__ + "media/images/xpass/markers/active-selected/kinrgy-8a4257ad30b0c1110b33d53720c09e8b.png";